import React, { useState } from "react";
import { Link, Outlet } from "react-router-dom";
import Header from "./header";
import ReactPixel from "react-facebook-pixel";
import { trackEvent } from "../../../services/events";

export type HomeContextType = {
    searchResultHeading: boolean;
    setSearchResultHeading: React.Dispatch<React.SetStateAction<boolean>>;
};

const HomePageLayout: React.FC = () => {
    const [searchResultHeading, setSearchResultHeading] = useState(false);

    const handleTrackButtonClick = (buttonName: string) => {
        trackEvent({
            event_name: {
                web: `Kirkos_Home_Page_Footer_${buttonName}_Click`,
                app: `Kirkos_Home_Page_Footer_${buttonName}_Click_App`,
            },
            event_category: "Footer_Link_Click",
            module: "HomePage",
            payload: { button_name: buttonName },
        }).catch(() => { });

        if (process.env.REACT_APP_META_PIXEL_ID) {
            try {
                ReactPixel.track("ButtonClick", {
                    content_name: buttonName,
                    content_category: "Footer Links",
                    content_type: "Link Click",
                    value: 0,
                    currency: "AED",
                });
            } catch (_) { }
        }
    };

    return (
        <div id="searchFormSection" className="div-home pb-4">
            <div className="landing-shell col-12  mx-auto">
                <Header isSearchActive={searchResultHeading} />
                <Outlet context={{ searchResultHeading, setSearchResultHeading } satisfies HomeContextType} />
            </div>
            {/* Full Footer */}
            <footer
                className="mt-4 landing-shell__footer"
                style={{
                    backgroundColor: "#0a0a0a",
                    borderTop: "1px solid #222",
                    padding: "2rem 1.5rem 1.25rem",
                }}
            >
                <div className="d-flex flex-wrap justify-content-center align-items-center gap-4 mb-3">
                    <Link
                        to="/contactus"
                        className="landing-shell__footer-link"
                        onClick={() => handleTrackButtonClick("Contact_Us")}
                    >Contact Us</Link>
                    <span style={{ color: "#444", fontSize: "0.75rem" }}>|</span>
                    <Link
                        to="/privacypolicy"
                        className="landing-shell__footer-link"
                        onClick={() => handleTrackButtonClick("Terms_Conditions")}
                    >Terms &amp; Conditions</Link>
                    {/* <span style={{ color: "#444", fontSize: "0.75rem" }}>|</span> */}
                    {/* <Link
            to="/signin"
            className="landing-shell__footer-link"
          >Customer Login</Link>
          <span style={{ color: "#444", fontSize: "0.75rem" }}>|</span>
          <Link
            to="/signinmerchant"
            className="landing-shell__footer-link"
          >Merchant Login</Link> */}
                </div>
                <div style={{ borderTop: "1px solid #1e1e1e", marginBottom: "1rem" }} />
                <div className="text-center">
                    <span style={{ color: "#555", fontSize: "0.72rem", letterSpacing: "0.06em" }}>
                        &copy; {new Date().getFullYear()}&nbsp;
                        <span style={{ color: "#F0B64F", fontWeight: 600 }}>KIRKOS</span>
                        &nbsp;&mdash; All Rights Reserved
                    </span>
                </div>
            </footer>
        </div>
    );
};

export default HomePageLayout;
